import { NativeEvent } from '../NativeEvent';

export interface ScreenViewPayload {
  event: 'screen_view';
  params: {
    screen_name: string;
    screen_class: string;
  };
}

/**
 * Reporta a rota atual como tela ao app nativo (contrato genérico `track`
 * do ENG-402). O trackRouter do app converte em `logScreenView` do GA4F,
 * substituindo o `MainActivity` do rastreio automático pelos paths reais.
 *
 * O split espelha as dimensões combinadas do GA4, para que as linhas de
 * app e web da mesma página se agreguem nos dois relatórios:
 *   - `screen_class` = path  → par do "caminho da página" (web);
 *   - `screen_name`  = título do documento (fallback: path) → par do
 *     "título da página" (web).
 * `screen_class` explícita também impede o SDK de defaultar para a
 * Activity nativa.
 */
export class ScreenViewEvent extends NativeEvent<'track', ScreenViewPayload> {
  readonly type = 'track';
  readonly payload: ScreenViewPayload;

  constructor(path: string, title?: string) {
    super();
    this.payload = {
      event: 'screen_view',
      params: { screen_name: title?.trim() || path, screen_class: path },
    };
  }

  protected override validate(): void {
    if (!this.payload.params.screen_class) {
      throw new Error('ScreenViewEvent: path é obrigatório');
    }
  }
}
